<template>
	<v-container class="background-2 pa-0 round-card pb-offset" fluid>
		<v-row class="ma-0">
			<v-col cols="12" class="pa-0">
				<v-card class="background-2 round-card mb-0 elevation-1 pa-1">
					<v-container class="pa-0" fluid>
						<v-subheader class="pl-5">
							Configurazione Importazione MEF
						</v-subheader>
						<v-divider></v-divider>
						<v-row class="ma-0 px-4">
							<v-col cols="12" class="pb-4">
								<v-switch
									inset
									v-model="integrationApp.active"
									label="Abilita importazione MEF"
									color="primary"
									hide-details
								></v-switch>
							</v-col>

							<template v-if="integrationApp.active">
								<v-col class="px-4 pb-2" cols="12" lg="6">
									<v-text-field
										label="Decimali prezzo"
										v-model="integrationApp.options.price_decimals"
										type="number"
										min="0"
										max="6"
										placeholder="2"
										hint="Numero di cifre decimali per i prezzi (0-6)"
										persistent-hint
										outlined
										dense
										prepend-icon="mdi-decimal-comma"
									></v-text-field>
								</v-col>

								<v-col class="px-4 pb-2" cols="12" lg="6">
									<v-switch
										inset
										v-model="integrationApp.options.import_description"
										label="Importa descrizione prodotto"
										color="primary"
										hint="Importa il campo descrizione estesa dei prodotti"
										persistent-hint
										class="mt-0"
									></v-switch>
								</v-col>

								<v-col class="px-4 pb-2" cols="12" lg="6">
									<v-switch
										inset
										v-model="integrationApp.options.use_product_supplier"
										label="Salva i prezzi sul listino fornitore"
										color="primary"
										hint="Se attivo, i prezzi MEF non aggiornano l'anagrafica prodotto ma creano/aggiornano il listino del fornitore collegato al catalogo"
										persistent-hint
										class="mt-0"
									></v-switch>
								</v-col>

								<v-col class="px-4 pb-2" cols="12" lg="6">
									<v-switch
										inset
										v-model="integrationApp.options.import_any_document"
										label="Pulsante importazione in tutti i documenti"
										color="primary"
										hint="Se un prodotto non viene trovato durante l'inserimento in un documento, propone l'importazione dal catalogo MEF anche se il fornitore non è collegato a MEF"
										persistent-hint
										class="mt-0"
									></v-switch>
								</v-col>
							</template>
						</v-row>
					</v-container>
					<template v-if="integrationApp.active">
						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn text @click="saveSettings()" color="primary" :loading="saving">Salva</v-btn>
						</v-card-actions>
					</template>
			</v-card>
		</v-col>
	</v-row>
</v-container>
</template>

<script>

export default {
	name: 'mef-settings',

	props: {
		id: {
			type: [Number, String],
			required: true
		}
	},

	data() {
		return {
			saving: false,
			integrationApp: {
				active: false,
				options: {
					price_decimals: 2,
					import_description: true,
					use_product_supplier: false,
					import_any_document: false
				}
			}
		}
	},

	mounted() {
		this.loadMefIntegration()
	},

	methods: {
		loadMefIntegration() {
			this.axios.get('integrationsapps/' + this.id).then(response => {
				const integrationData = response.data.data
				this.integrationApp = {
					...this.integrationApp,
					...integrationData,
					options: {
						...this.integrationApp.options,
						...(integrationData.options || {})
					}
				}
				this.$store.commit('endProgress')
			}).catch(error => {
				console.error('Errore caricamento integrazione MEF:', error)
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: 'Errore caricamento configurazione MEF',
					value: true,
					color: 'error'
				})
			}).finally(() => {
				this.$store.commit('endProgress')
			})
		},

		saveSettings() {
			this.saving = true

			if (!this.integrationApp.id) {
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: 'Errore: integrazione MEF non trovata',
					value: true,
					color: 'error'
				})
				this.saving = false
				return
			}

			this.axios.put(`integrationsapps/${this.integrationApp.id}`, {
				active: this.integrationApp.active,
				options: this.integrationApp.options
			}).then(() => {
				this.saving = false
				// aggiorna subito il flag usato dai documenti, senza ricaricare la pagina
				this.$store.commit('SET_TENANT_FLAG', {
					key: 'mef_import_any_document',
					value: !!(this.integrationApp.active && this.integrationApp.options.import_any_document)
				})
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: 'Impostazioni MEF salvate con successo',
					value: true,
					color: 'success'
				})
			}).catch(error => {
				this.saving = false
				console.error('Errore salvataggio impostazioni MEF:', error)
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: 'Errore salvataggio impostazioni MEF',
					value: true,
					color: 'error'
				})
			})
		}
	}
}
</script>
